let timer = null;
import { zh } from "@/components/DatePicker/locale";
import moment from "moment";
//API
import { computeAge } from "@/service";
import Vue from "vue";
export default {
  filters: {
    formatMethods(source = "") {
      let sourceString = source + "";
      let FloatString =
        sourceString == ""
          ? ""
          : Math.ceil(parseFloat(sourceString)).toFixed(0);
      return FloatString.split("")
        .reverse()
        .map((char, i) => {
          return i % 3 == 0 && i != 0 ? char + "," : char;
        })
        .reverse()
        .join("");
    },
  },
  data() {
    return {
      dateLang: zh,
      dateFormatter: (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear() - 1911}/${(m < 10 ? "0" : "") + m}/${(d <
        10
          ? "0"
          : "") + d}`;
      },
    };
  },
  computed: {
    isMxf1() {
      // MF 子頁只有嵌在新版 MXF1 時，才回傳客戶給父頁。
      const parentOrigin = this.getMxf1ParentOrigin();
      const isMxf1Host = /^https:\/\/(tagpaas|sagpaas|agpaas)\.cathaylife\.com\.tw$/.test(
        parentOrigin
      );

      return isMxf1Host;
    },
  },
  methods: {
    getMxf1ParentOrigin() {
      if (!document.referrer) return "";

      try {
        return new URL(document.referrer).origin;
      } catch (error) {
        return "";
      }
    },
    postMxf1Customer(csid) {
      // MXF1 母頁負責接收客戶並導向新版客戶頁，iframe 不再同步跳轉舊 detail 頁。
      if (!this.isMxf1 || !csid) return false;

      const parentOrigin = this.getMxf1ParentOrigin();
      if (!parentOrigin) return false;

      window.parent.postMessage(
        {
          type: "SET_CSID",
          // 沿用新版 MXF1 既有的 Base64 客戶識別協議，無 ID 的「~serNo」也保留原值。
          csid: btoa(csid),
        },
        parentOrigin
      );
      return true;
    },
    numberHandler(targetObject, key, { target: el }) {
      if (timer) {
        timer = clearTimeout(timer);
      }
      timer = setTimeout(() => {
        let value = el.value.replace(/[^0-9]/gi, "");
        targetObject[key] = value == "" ? "" : parseInt(value).toString();
        this.$forceUpdate();
      }, 1);
    },
    async birthdayChecker($event, target, errorName) {
      if (!$event) return false;
      if (moment($event).isAfter(moment())) {
        this.$toast.info({
          title: "生日不可大於今日!",
        });
        target.birthdayError = true;
        setTimeout(() => {
          this.errors.remove(errorName);
          target.insured_birthday = "";
          target.insured_age = "";
          this.$forceUpdate();
        }, 100);
        return false;
      } else {
        target.insured_birthday = $event
          ? moment($event).format("YYYY-MM-DD")
          : "";
        target.birthdayError = false;
        this.errors.remove(errorName);
        //
        const res = await computeAge(
          this.$store.state.userInfo.id,
          moment($event).format("YYYY-MM-DD")
        );
        target.insured_age = res.body.age + "";
        this.$forceUpdate();
        return true;
      }
    },
    birthdayFormatForDatePick(date, target) {
      if (!date) {
        setTimeout(() => {
          if (this.$refs[target].length) {
            this.$refs[target][0].clearDate();
          } else {
            this.$refs[target].clearDate();
          }
        }, 10);
      }
      let dateObj = new Date(date);
      let stringArray = dateObj
        .toLocaleString("TW")
        .split(" ")[0]
        .split("/");
      let y = dateObj.getFullYear() - 1911;
      y = y < 100 ? "0" + y.toString() : y.toString();
      let m = String(dateObj.getMonth() + 1).padStart(2, '0');
      let d = String(dateObj.getDate()).padStart(2, '0');
      return `${y}${m}${d}`;
    },
    // 清除生日
    clearBirthday(target) {
      const keepSameInsurer = target === "insurer" && this.sameInsurer;

      this.customerChangeHandler(() => {
        this.$refs[`${target}_dataPicker`].clearDate();
        setTimeout(() => {
          this[target].insured_birthday = "";
          this[target].insured_age = "";
          this.$refs[`${target}_dataPicker`].clearDate();
          if (keepSameInsurer) {
            this.insured = this.insurer;
            this.sameInsurer = true;
          } else {
            this.sameInsurer = false;
            this.insurer = _.cloneDeep(this.insurer);
            this.insured = _.cloneDeep(this.insured);
          }
          this.$forceUpdate();
        });
      });
    },
    //檢查輸入年紀
    ageHandler(target) {
      target.insured_age = target.insured_age.replace(/[^\d]/g, "");
      target.insured_birthday = "";
      target.birthdayError = false;
    },
    //年齡格式化
    ageFormat(obj, key) {
      obj[key] = obj[key].replace(/[^\d]/g, "") + "";
      this.$forceUpdate();
    },
    //讓字串str只呈現n個字，其餘顯示...
    truncate(str, n = 12) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    //文字格式化後取長度
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    floatHandler(Object, key) {
      //只能輸入至小數點一位
      let numberString = Object[key];
      let numberArray = numberString.split(".");
      if (numberArray[1]) {
        let string = numberArray[1].toString().slice(0, 1);
        Object[key] = `${numberArray[0]}.${string}`;
      }
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate)
          .format("YYYY-MM-DD")
          .split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    formatMethods(source = "") {
      let sourceString = source + "";
      let FloatString =
        sourceString == ""
          ? ""
          : Math.ceil(parseFloat(sourceString)).toFixed(0);
      return FloatString.split("")
        .reverse()
        .map((char, i) => {
          return i % 3 == 0 && i != 0 ? char + "," : char;
        })
        .reverse()
        .join("");
    },
    //更新clickdate
    updateClickDate(
      prod_idx = this.$store.getters.MfViewing.prod_idx,
      prod_type = this.$store.getters.MfViewing.prod_type || "1"
    ) {
      if (!prod_idx) return;
      switch (prod_type) {
        case "2":
          //更新投資型
          this.$mfAPI.MFA1_1000__saveProposalClickDate({
            prod_idx: prod_idx,
          });
          break;
        default:
          //更新傳統型
          this.$mfAPI.MFA0_1000__saveProposalClickDate({
            prod_idx: prod_idx,
          });
      }
    },
    //單位+幣別顯示
    unit_curr(amtunit, curr) {
      let amtunit_nm = "";
      let amtunitList = Vue.prototype.$paragrpno.amt_unit || [];
      let curr_nm = "";
      let currList = Vue.prototype.$paragrpno.curr || [];

      let amtunit_target = amtunitList.find((item) => {
        return item.paraval == amtunit;
      });
      if (amtunit_target) {
        amtunit_nm = amtunit_target.paradetlno.replace("元", "");
      }

      let curr_target = currList.find((item) => {
        return item.paraval == curr;
      });
      if (curr_target) {
        curr_nm = curr_target.paraval == "NTD" ? "元" : curr_target.paradetlno;
      }
      if (amtunit == "7" || amtunit == "8") {
        curr_nm = "";
      }
      return amtunit_nm + curr_nm;
    },
    //幣別轉換(幣別,是否顯示'元')
    currTranser(curr, showDefault = false) {
      if (showDefault && curr == "NTD") {
        return "元";
      } else if (curr == "NTD") {
        return "";
      }
      let currList = Vue.prototype.$paragrpno.curr || [];
      let curr_target = currList.find((item) => {
        return item.paraval == curr;
      });
      if (curr_target) {
        return curr_target.paradetlno;
      }
      return "";
    },
    getPay_freq_nm(paraval) {
      return this.$paragrpno.pay_freq.find((item) => {
        return item.paraval == paraval;
      }).paradetlno;
    },
    //判斷該商屬在目前的選擇下是否能保
    getProdvalid(
      PRODUCT_FEATURE_DATA,
      insured_age,
      pay_prd,
      pol_period = "",
      type = "主約",
      insured_birthday = "",
      deferred_prod,
      insured_sex = ""
    ) {
      let errorMessage = "";
      let errorReason = "一般";
      let isFullyear = false;
      let insured_age_floor = insured_age; //被保人年齡(檢核下限用，預設值:保險年齡)
      //區分法定年齡與保險年齡邏輯(2022/3/18新增 )
      if (PRODUCT_FEATURE_DATA.age_floor_kind == "2") {
        isFullyear = true;
      }
      if (
        PRODUCT_FEATURE_DATA.age_floor_kind == "2" &&
        insured_birthday != ""
      ) {
        insured_age_floor = moment().diff(moment(insured_birthday), "years");
      }
      //判斷年齡區間是否符合(判斷amt_ind_list(優先)或age_ind_list)
      let age_ind_list = PRODUCT_FEATURE_DATA.age_ind_list;
      let amt_ind_list = PRODUCT_FEATURE_DATA.amt_ind_list;
      let ageRangeList = [];
      if (age_ind_list) {
        ageRangeList = age_ind_list.filter((item) => {
          if (item.pay_prd && item.reserve_col != "-1") {
            if (
              PRODUCT_FEATURE_DATA.pol_period.split(",").length > 1 ||
              PRODUCT_FEATURE_DATA.pol_period.split("~").length > 1
            ) {
              errorReason = "保險期間";
              if (item.pay_prd && item.pay_prd != "-1") {
                return (
                  item.pay_prd == pay_prd && item.reserve_col == pol_period
                );
              } else {
                return item.reserve_col == pol_period;
              }
            } else if (
              PRODUCT_FEATURE_DATA.deferred_prod &&
              PRODUCT_FEATURE_DATA.deferred_prod.split(",").length > 0
            ) {
              //遞延年金檢核(8/10新增)
              errorReason = "遞延期間";
              if (item.pay_prd && item.pay_prd != "-1") {
                return (
                  item.pay_prd == pay_prd && item.reserve_col == deferred_prod
                );
              } else {
                return item.reserve_col == deferred_prod;
              }
            } else {
              errorReason = "繳費年期";
              return item.pay_prd == pay_prd;
            }
          } else if (item.pay_prd != "-1") {
            errorReason = "繳費年期";
            return item.pay_prd == pay_prd;
          }
        });
      }
      if (amt_ind_list) {
        ageRangeList = amt_ind_list.filter((item) => {
          if (item.pay_prd != "-1") {
            errorReason = "繳費年期";
            return item.pay_prd == pay_prd;
          }
        });
      }
      let age_floor;
      let age_ceil;
      try {
        age_floor = ageRangeList[0].age_floor;
        age_ceil = ageRangeList[0].age_ceil;
        ageRangeList.forEach((ageRange) => {
          if (parseInt(ageRange.age_floor) < parseInt(age_floor)) {
            age_floor = ageRange.age_floor;
          }
          if (parseInt(ageRange.age_ceil) > parseInt(age_ceil)) {
            age_ceil = ageRange.age_ceil;
          }
        });
      } catch {
        age_floor = PRODUCT_FEATURE_DATA.age_floor;
        age_ceil = PRODUCT_FEATURE_DATA.age_ceil;
      }
      ageRangeList.forEach((item) => {
        if (parseInt(item.age_floor) < parseInt(age_floor))
          age_floor = item.age_floor;
        if (parseInt(item.age_ceil) > parseInt(age_ceil))
          age_ceil = item.age_ceil;
      });
      // 繳費期滿不超過
      if (
        parseInt(PRODUCT_FEATURE_DATA.matur_age_ceil) > 0 &&
        (parseInt(insured_age_floor) < parseInt(age_floor) ||
          parseInt(insured_age) > parseInt(age_ceil) ||
          parseInt(insured_age) + parseInt(pay_prd) >
            parseInt(PRODUCT_FEATURE_DATA.matur_age_ceil))
      ) {
        if (PRODUCT_FEATURE_DATA.pay_period_matur === "1") {
          errorMessage = `選擇${pay_prd}歲滿期，主約被保險人限${age_floor}${
            isFullyear ? "足" : ""
          }歲至${age_ceil}歲。`;
        } else {
          errorMessage = `${
            type == "主約" ? "主約被保險人" : ""
          }限${age_floor}${
            isFullyear ? "足" : ""
          }歲至${age_ceil}歲；繳費期滿不超過${
            PRODUCT_FEATURE_DATA.matur_age_ceil
          }歲。`;
        }
      }
      // 繳費年期設定條件的年齡限制區間
      else if (
        parseInt(insured_age_floor) < parseInt(age_floor) ||
        parseInt(insured_age) > parseInt(age_ceil)
      ) {
        if (PRODUCT_FEATURE_DATA.pay_period_matur === "1") {
          errorMessage = `選擇${pay_prd}歲滿期，${
            type == "主約" ? "主約被保險人" : ""
          }限${age_floor}${isFullyear ? "足" : ""}歲至${age_ceil}歲。`;
        }
        switch (errorReason) {
          case "一般":
            errorMessage = `${
              type == "主約" ? "主約被保險人" : ""
            }限${age_floor}${
              isFullyear && age_floor != 0 ? "足" : ""
            }歲至${age_ceil}歲。`;
            break;
          case "繳費年期":
            errorMessage = `選擇繳費年期${pay_prd}年，${
              type == "主約" ? "主約被保險人" : ""
            }限${age_floor}至${age_ceil}歲。`;
            break;
          case "保險期間":
            errorMessage = `選擇繳費年期${pay_prd}年，選擇保險期間${pol_period}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
            break;
          case "遞延期間":
            errorMessage = `選擇繳費年期${pay_prd}年，選擇遞延期間${pol_period}年，主約被保險人限${age_floor}歲至${age_ceil}歲`;
        }
      }
      // 年期不符合
      if (PRODUCT_FEATURE_DATA.pay_prd_no != "" && pay_prd) {
        if (PRODUCT_FEATURE_DATA.pay_prd_no.indexOf("、") > -1) {
          if (PRODUCT_FEATURE_DATA.pay_prd_no.indexOf(pay_prd) < 0) {
            errorMessage =
              errorMessage + `限主約為${PRODUCT_FEATURE_DATA.pay_prd_no}年期。`;
          }
        } else if (PRODUCT_FEATURE_DATA.pay_prd_no.indexOf("~") > -1) {
          let [floor, ceil] = PRODUCT_FEATURE_DATA.pay_prd_no.split("~");
          if (parseInt(pay_prd) < floor || parseInt(pay_prd) > ceil) {
            errorMessage =
              errorMessage + `限主約為${PRODUCT_FEATURE_DATA.pay_prd_no}年期。`;
          }
        } else if (
          PRODUCT_FEATURE_DATA.prod_cat == "2" &&
          PRODUCT_FEATURE_DATA.pay_prd_no != pay_prd
        ) {
          errorMessage =
            errorMessage + `限主約為${PRODUCT_FEATURE_DATA.pay_prd_no}年期。`;
        }
      }
      //性別限制提示
      let prod_sex = PRODUCT_FEATURE_DATA.gender_ind;
      if (prod_sex != 0 && insured_sex != prod_sex)
      {
        let sexStr = this.$paragrpno.gender_ind.filter((item) => item.paraval === prod_sex).map((item) => item.paradetlno);
        errorMessage =
          errorMessage + "限" + sexStr + "性。";
      }
      return errorMessage;
    },
    //判斷日額通算
    checkDailyCalculate(proposalMap) {
      let delationedSaveData = this.deflationSaveData(proposalMap);
      return new Promise((allCheckRes) => {
        this.$mfAPI
          .MFC0_1100__checkDailyCalculate({ proposalMap: delationedSaveData })
          .then((res) => {
            new Promise((sickCheck) => {
              //先處理疾病
              if (res.checkSickAmtMap.isAlert) {
                let sickDetailMsg = "";
                proposalMap.mc_prod_list.forEach((mc, index) => {
                  if (res.checkSickAmtMap.checkMsgList[index].checkMsg != "") {
                    sickDetailMsg += `<strong>建議${index + 1}:${
                      mc.prod_name
                    }(${mc.prod_id})</strong>
                    ${
                      res.checkSickAmtMap.checkMsgList[index].checkMsg
                    }</br></br>
                    `;
                  }
                });
                sickDetailMsg += `</br><strong>${
                  res.checkSickAmtMap.checkMaxCeilMsg
                }</strong>`;
                this.$mfNotice(
                  "請注意! 以下建議的疾病住院醫療日額通算已超過規定!",
                  () => {
                    res.checkSickAmtMap.isSave
                      ? setTimeout(() => sickCheck(true), 200)
                      : allCheckRes(false);
                  },
                  null,
                  false,
                  "確定",
                  sickDetailMsg
                );
              } else {
                res.checkSickAmtMap.isSave
                  ? sickCheck(true)
                  : allCheckRes(false);
              }
            })
              .then(() => {
                new Promise((HarmCheck) => {
                  //傷害日額通算
                  if (res.checkHarmAmtMap.isAlert) {
                    let harmDetailMsg = "";
                    proposalMap.mc_prod_list.forEach((mc, index) => {
                      if (
                        res.checkHarmAmtMap.checkMsgList[index].checkMsg != ""
                      ) {
                        harmDetailMsg += `<strong>建議${index + 1}:${
                          mc.prod_name
                        }(${mc.prod_id})</strong>
                    ${
                      res.checkHarmAmtMap.checkMsgList[index].checkMsg
                    }</br></br>
                    `;
                      }
                    });
                    harmDetailMsg += `</br><strong>${
                      res.checkHarmAmtMap.checkMaxCeilMsg
                    }</strong>`;
                    this.$mfNotice(
                      "請注意! 以下建議的傷害住院醫療日額通算已超過規定!",
                      () => {
                        res.checkHarmAmtMap.isSave
                          ? allCheckRes(true)
                          : allCheckRes(false);
                      },
                      null,
                      false,
                      "確定",
                      harmDetailMsg
                    );
                  } else {
                    res.checkHarmAmtMap.isSave
                      ? HarmCheck(true)
                      : allCheckRes(false);
                  }
                });
              })
              .then(() => {
                //附約疾病住院日額通算
                if (res.checkRiderSickAmtMap.isAlert) {
                  let harmDetailMsg = "";
                  proposalMap.mc_prod_list.forEach((mc, index) => {
                    if (
                      res.checkRiderSickAmtMap.checkMsgList[index].checkMsg !=
                      ""
                    ) {
                      harmDetailMsg += `<strong>建議${index + 1}:${
                        mc.prod_name
                      }(${mc.prod_id})</strong>
                    ${
                      res.checkRiderSickAmtMap.checkMsgList[index].checkMsg
                    }</br></br>
                    `;
                    }
                  });
                  harmDetailMsg += `</br><strong>${
                    res.checkRiderSickAmtMap.checkMaxCeilMsg
                  }</strong>`;
                  this.$mfNotice(
                    "請注意! 以下建議的傷害住院醫療日額通算已超過規定!",
                    () => {
                      res.checkRiderSickAmtMap.isSave
                        ? allCheckRes(true)
                        : allCheckRes(false);
                    },
                    null,
                    false,
                    "確定",
                    harmDetailMsg
                  );
                } else {
                  res.checkRiderSickAmtMap.isSave
                    ? allCheckRes(true)
                    : allCheckRes(false);
                }
              });
          });
      });
    },
    //檢核儲存建議書
    checkSaveProposal(proposalMap, isSave = false) {
      return new Promise((allCheckRes) => {
        this.$mfAPI
          .MFA0_1000__checkSaveProposal({ proposalMap })
          .then((res) => {
            new Promise((resolve) => {
              //第一步驟:保額互相限制
              if (res.checkAmtLimit4Map.isAlert) {
                let detailMsg = "";
                proposalMap.mc_prod_list.forEach((mc, index) => {
                  if (res.checkAmtLimit4Map.checkMsgList[index].length > 0) {
                    detailMsg += `<strong>建議${index + 1}:${mc.prod_name}(${
                      mc.prod_id
                    })</strong></br>
                    ${res.checkAmtLimit4Map.checkMsgList[index].join(
                      "</br></br>"
                    )}</br></br>
                    `;
                  }
                });
                this.$mfNotice(
                  "請注意！以下建議已違反附約保額限制!",
                  () => {
                    res.checkAmtLimit4Map.isSave
                      ? setTimeout(() => resolve(), 200)
                      : allCheckRes(false);
                  },
                  null,
                  false,
                  "確定",
                  detailMsg
                );
              } else {
                res.checkAmtLimit4Map.isSave ? resolve() : allCheckRes(false);
              }
            })
              .then(() => {
                //第二步驟:實支保額互相限制
                return new Promise((resolve) => {
                  if (res.checkAmtInd1Map.isAlert) {
                    let detailMsg = "";
                    proposalMap.mc_prod_list.forEach((mc, index) => {
                      if (res.checkAmtInd1Map.checkMsgList[index].length > 0) {
                        detailMsg += `<strong>建議${index + 1}:${
                          mc.prod_name
                        }(${mc.prod_id})</strong></br>
                    ${res.checkAmtInd1Map.checkMsgList[index].join(
                      "</br></br>"
                    )}</br></br>
                    `;
                      }
                    });
                    this.$mfNotice(
                      "請注意！以下建議已違反實支實付保額限制！",
                      () => {
                        res.checkAmtInd1Map.isSave
                          ? setTimeout(() => resolve(), 200)
                          : allCheckRes(false);
                      },
                      null,
                      false,
                      "確定",
                      detailMsg
                    );
                  } else {
                    res.checkAmtInd1Map.isSave ? resolve() : allCheckRes(false);
                  }
                });
              })
              .then(() => {
                //第三步驟:疾病日額通算
                return new Promise((resolve) => {
                  if (res.checkSickAmtMap.isAlert) {
                    let detailMsg = "";
                    proposalMap.mc_prod_list.forEach((mc, index) => {
                      if (
                        res.checkSickAmtMap.checkMsgList[index].checkMsg != ""
                      ) {
                        detailMsg += `<strong>建議${index + 1}:${
                          mc.prod_name
                        }(${mc.prod_id})</strong>
                    ${
                      res.checkSickAmtMap.checkMsgList[index].checkMsg
                    }</br></br>
                    `;
                      }
                    });
                    detailMsg += `</br><strong>${
                      res.checkSickAmtMap.checkMaxCeilMsg
                    }</strong>`;
                    this.$mfNotice(
                      "請注意! 以下建議的疾病住院醫療日額通算已超過規定!",
                      () => {
                        res.checkSickAmtMap.isSave
                          ? setTimeout(() => resolve(), 200)
                          : allCheckRes(false);
                      },
                      null,
                      false,
                      "確定",
                      detailMsg
                    );
                  } else {
                    res.checkSickAmtMap.isSave ? resolve() : allCheckRes(false);
                  }
                });
              })
              .then(() => {
                //第四步驟:傷害日額通算
                return new Promise((resolve) => {
                  if (res.checkHarmAmtMap.isAlert) {
                    let detailMsg = "";
                    proposalMap.mc_prod_list.forEach((mc, index) => {
                      if (
                        res.checkHarmAmtMap.checkMsgList[index].checkMsg != ""
                      ) {
                        detailMsg += `<strong>建議${index + 1}:${
                          mc.prod_name
                        }(${mc.prod_id})</strong>
                      ${
                        res.checkHarmAmtMap.checkMsgList[index].checkMsg
                      }</br></br>
                      `;
                      }
                    });
                    detailMsg += `</br><strong>${
                      res.checkHarmAmtMap.checkMaxCeilMsg
                    }</strong>`;
                    this.$mfNotice(
                      "請注意! 以下建議的傷害住院醫療日額通算已超過規定!",
                      () => {
                        res.checkHarmAmtMap.isSave
                          ? allCheckRes(true)
                          : allCheckRes(false);
                      },
                      null,
                      false,
                      "確定",
                      detailMsg
                    );
                  } else {
                    res.checkHarmAmtMap.isSave ? resolve() : allCheckRes(false);
                  }
                });
              })
              .then(() => {
                //第五步驟: 附約疾病住院日額通算
                if (res.checkRiderSickAmtMap.isAlert) {
                  let detailMsg = "";
                  proposalMap.mc_prod_list.forEach((mc, index) => {
                    if (
                      res.checkRiderSickAmtMap.checkMsgList[index].checkMsg !=
                      ""
                    ) {
                      detailMsg += `<strong>建議${index + 1}:${mc.prod_name}(${
                        mc.prod_id
                      })</strong>
                    ${
                      res.checkRiderSickAmtMap.checkMsgList[index].checkMsg
                    }</br></br>
                    `;
                    }
                  });
                  detailMsg += `</br><strong>${
                    res.checkRiderSickAmtMap.checkMaxCeilMsg
                  }</strong>`;
                  this.$mfNotice(
                    "請注意! 以下建議的附約疾病住院醫療日額通算已超過規定!",
                    () => {
                      res.checkRiderSickAmtMap.isSave
                        ? allCheckRes(true)
                        : allCheckRes(false);
                    },
                    null,
                    false,
                    "確定",
                    detailMsg
                  );
                } else {
                  res.checkRiderSickAmtMap.isSave
                    ? allCheckRes(true)
                    : allCheckRes(false);
                }
              });
          });
      });
    },
    getPay_freq_nm(paraval) {
      return this.$paragrpno.pay_freq.find((item) => {
        return item.paraval == paraval;
      }).paradetlno;
    },
    //通路別卡控商品列表
    channelTypeFilter(prod_list) {
      return prod_list.filter((item) => {
        if (
          this.$store.getters.UserChannelType == "1" &&
          item.channel_type.indexOf("1") > -1
        ) {
          return true;
        } else if (
          this.$store.getters.UserChannelType == "2" &&
          item.channel_type.indexOf("2") > -1 &&
          item.channel_type != "2,3"
        ) {
          return true;
        } else if (
          this.$store.getters.UserChannelType == "3" &&
          item.channel_type.indexOf("3") > -1
        ) {
          return true;
        }
        return false;
      });
    },
    //建議書物件瘦身，減少mc_prod_list內不必要的參數
    deflationSaveData(saveData) {
      let Obj = _.cloneDeep(saveData);
      Obj.mc_prod_list.forEach((mc) => {
        delete mc.FEATURE_DATA;
        delete mc.temp__addPayment;
        delete mc.pol_endage_tmp;
        delete mc.ScPopup;
        delete mc.rider_type_nm;
        delete mc.estimatePremiumError;
        delete mc.premiumShow;
        delete mc.uniqueKey;
        delete mc.prod_nameAndId;
        delete mc.channel_type;
        delete mc.estimatePremium;
        delete mc.prod_cat_nm;
        delete mc.prod_type_nm;
        mc.sc_prod_list = mc.sc_prod_list.map((sc, index) => {
          return {
            prod_idx: sc.prod_idx || "",
            mc_idx: sc.mc_idx || "",
            sc_idx: sc.sc_idx || "",
            prod_id: sc.prod_id,
            relationship: sc.relationship,
            insured_name: sc.insured_name,
            insured_id: sc.insured_id,
            insured_gender: sc.insured_gender,
            insured_birthday: sc.insured_birthday,
            insured_age: sc.insured_age,
            pay_prd: sc.pay_prd,
            amt: sc.amt,
            amt_unit: sc.amt_unit,
            job_cat: sc.job_cat,
            level: sc.level || "",
            pay_dis: mc.pay_dis || "0",
            group_dis: mc.group_dis || "0",
            premium: sc.premium,
            sc_order: index,
            free_prod: sc.free_prod,
          };
        });
      });
      return Obj;
    },
    async checkProdWhiteList(prod_id, csid) {
      //判斷商品是否在白名單中
      let message = "";
      let value = this.$prod_white_list(prod_id);
      if (value != "") {
        try {
          let temp = value.split(",");
          let errorMessage =
            "本商品係針對公司預先篩選之客戶限定銷售，客戶不在名單內不得投保。名單查詢路徑：" +
            temp[1];
          if (csid == "") {
            return errorMessage;
          }
          let hasAgentId = !(temp.length === 3 && "N" === temp[2]); //不須限定經手人:  agid(業務ID)傳空值
          let result = await this.$mfAPI.getAgInfo({
            ser_no: temp[0],
            csid,
            agid: hasAgentId ? this.$store.state.userInfo.id : "",
          });
          if (
            result.dataList.length > 0 &&
            "Y" != result.dataList[0].qualified
          ) {
            message = errorMessage;
          }
        } catch (e) {
          console.log("白名單API異常");
        }
      }
      return message;
    },
    //計算字元長度 (字串, 是否檢查, 檢查的長度)
    stringBytesLength(c, isSub, size) {
      var n = c.length,
        s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    //檢查輸入欄位
    checkSpecialKeyword(keyword) {
      let wordType = "";
      wordType = keyword.replace(/[<>!@#$^&,."'?%;_()+-/{}[\]|~`=\\\s]/g, "");
      if (this.stringBytesLength(wordType, false, 100) > 100) {
        wordType = wordType.substring(
          0,
          this.stringBytesLength(wordType, true, 100)
        );
      }
      return wordType;
    },
    // 商品清單-風險種類
    selectedRisk(item) {
      if (item.hasOwnProperty("risk_ind")) {
        return item.risk_ind !== "" ? "(" + item.risk_ind_nm + ")" : " ";
      } else {
        return " ";
      }
    },
    //產品風險屬性提示文字
    insuredRiskWarnText(id, attribute, item) {
      let riskObj = item.riskObj;
      let text = "";
      let kyc_lvl = "";
      // 空白建議書
      let hasNoID = id === "";
      if (hasNoID) {
        riskObj = {};
      } else if (!riskObj) {
        // kyc api 異常
        return "";
      }

      let warnText = "";
      //----------------hasNoID=true 空白建議書，message 不是api的值，--------------------------------
      //----------------hasNoID=false, message 為 api 回傳的值---------------------------------------
      // product 產品風險屬性 kyc_message
      if (attribute === "product") {
        if (hasNoID) {
          riskObj.kyc_message =
            "要保人近一年無有效風險屬性，建議書僅可內部使用，會以浮水印提醒不得對外行銷使用";
        }
        text = riskObj.kyc_message;
        warnText =
          "要保人投資風險屬性與本商品風險類型不符，建議書僅可內部使用，會以浮水印提醒不得對外行銷使用、並不得匯入行動投保";
      } else if (attribute === "printTitle") {
        // print 列印建議書標題 kyc_printtitle_message
        if (hasNoID) {
          riskObj.kyc_printtitle_message = "本份建議書不得作為新契約銷售文件!";
        }
        text = riskObj.kyc_printtitle_message;
        warnText = "本份建議書不得作為新契約銷售文件!";
      } else if (attribute === "print") {
        // print 列印建議書內容 kyc_print_message
        if (hasNoID) {
          riskObj.kyc_print_message =
            "空白建議書試算將有提醒浮水印，不得作為新契約銷售文件";
        }
        text = riskObj.kyc_print_message;
        warnText =
          "要保人投資風險屬性與本商品風險類型不符，產出的建議書將有提醒浮水印，不得作為新契約銷售文件，建議更換商品或是要保人";
      } else if (attribute === "importMobile") {
        // importMobile 匯入行動投保  kyc_mi_message
        text = riskObj.kyc_mi_message;
        warnText = "要保人投資風險屬性與本商品風險類型不符，不得匯入行動投保";
      } else if (attribute === "ivCard") {
        // ivCard 投資型卡牌  kyc_list_message
        if (hasNoID) {
          riskObj.kyc_list_message = "要保人近一年無有效風險屬性";
        }
        text = riskObj.kyc_list_message;
        warnText = "要保人投資風險屬性與本商品風險類型不符";
      }
      if (hasNoID && text !== undefined) {
        // 空白建議書 浮水印是粗體紅字
        const redText = text.replace(
          /浮水印/g,
          '<span style="color:#de4054;font-weight:800">浮水印</span>'
        );
        return redText;
      } else {
        kyc_lvl = riskObj.kyc_lvl;
      }
      //--------------- KYC 風險屬性提示顯示---------------------------------
      if (text === "") {
        return this.kycLogic(kyc_lvl, item, warnText); // KYC 邏輯處理
      } else {
        if (text !== undefined) {
          // 字串浮水印處理粗體紅字
          let isWaterMark = text.indexOf("浮水印");
          if (isWaterMark !== -1) {
            const redText = text.replace(
              /浮水印/g,
              '<span style="color:#de4054;font-weight:800">浮水印</span>'
            );
            return redText;
          }
          return text;
        }
      }
    },
    // KYC 邏輯處理
    kycLogic(kyc_lvl, item, warnText) {
      if (item.hasOwnProperty("risk_ind")) {
        if (
          (kyc_lvl === "2" && item.risk_ind === "3") ||
          (kyc_lvl === "1" && (item.risk_ind === "2" || item.risk_ind === "3"))
        ) {
          // 字串浮水印處理粗體紅字
          let isWaterMark = warnText.indexOf("浮水印");
          if (isWaterMark !== -1) {
            const redText = warnText.replace(
              /浮水印/g,
              '<span style="color:#de4054;font-weight:800">浮水印</span>'
            );
            return redText;
          }
          return warnText;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    //證照卡控
    async inquireQualificationByKind4CSR(toImportList, ismfNotice = false) {
      let isOK = {
        hasInquireQualification: true, //有無商品證照招攬資格
        hasEldQualification: true, //有無高齡招攬資格
        hasQualification: true, //使否通過檢核
      };
      //以下單位不須檢核"9400400", "9N00200", "9F00300", "6500300", "5700400","5200100"
      if (
        toImportList &&
        ![
          "9400400",
          "9N00200",
          "9F00300",
          "6500300",
          "5700400",
          "5200100",
        ].includes(this.$store.getters.UserInfo.divNo)
      ) {
        let set = new Set();
        for (let i = 0; i < toImportList.length; i++) {
          let certi_type = toImportList[i].certi_type
            ? toImportList[i].certi_type
            : toImportList[i].FEATURE_DATA
              ? toImportList[i].FEATURE_DATA.certi_type
              : "";

          if (certi_type) {
            set.add(certi_type);
          }
        }

        isOK.hasInquireQualification = await this.checkInquireQualificationByKind4CSR(
          Array.from(set),
          ismfNotice
        );
        if (
          isOK.hasInquireQualification &&
          (this.MfViewing.saveData.insurer_age >= 65 ||
            this.MfViewing.saveData.insured_age >= 65)
        ) {
          //要被保人年齡若>=65，則查看是否有高齡招攬資格
          isOK.hasEldQualification = await this.checkEldQualification(
            ismfNotice
          );
        }
      }
      isOK.hasQualification =
        isOK.hasInquireQualification && isOK.hasEldQualification;
      return isOK;
    },
    //證照卡控
    async checkInquireQualificationByKind4CSR(
      recruitmentTypeList,
      ismfNotice = false
    ) {
      let isOK = true;
      return new Promise(async (res) => {
        if (recruitmentTypeList.length != 0) {
          try {
            let recruitmentType = recruitmentTypeList.shift();
            let qualificationObj = this.$store.getters.QualificationObj;
            let validRes = qualificationObj
              ? qualificationObj[recruitmentType]
              : null;
            if (!validRes) {
              //未讀取過招攬資格
              validRes = {
                ...(await this.$mfAPI.MFA0_2100__inquireQualificationByKind4CSR(
                  {
                    agent_id: this.$store.getters.UserInfo.id,
                    recruitmentType,
                    isBankUser: this.$store.getters.UserInfo.compId === "01",
                  }
                )),
              };
              if (validRes.returnCode == "0") {
                qualificationObj[recruitmentType] = validRes;
                this.$store.commit("set_qualificationObj", qualificationObj);
              }
            } else {
              await new Promise((resolve) => setTimeout(resolve, 200)); //防止程式連續執行
            }
            if (validRes.hasQualification == "N") {
              //無招攬資格
              isOK = false;
              //遇到N回傳FALSE，並顯示錯誤訊息
              if (ismfNotice) {
                this.$mfNotice(
                  validRes.message_title,
                  async () => {
                    if (validRes.returnCode == "0") {
                      this.checkInquireQualificationByKind4CSR(
                        recruitmentTypeList,
                        ismfNotice
                      );
                    }
                  },
                  false,
                  () => {},
                  "確定",
                  validRes.message_body
                );
              } else {
                //黑底白字訊息
                this.$toast.info({
                  title: validRes.message,
                });
                this.checkInquireQualificationByKind4CSR(
                  recruitmentTypeList,
                  ismfNotice
                );
              }
            } else {
              //檢核成功，如有其他種類繼續檢核
              if (recruitmentTypeList.length != 0) {
                this.checkInquireQualificationByKind4CSR(
                  recruitmentTypeList,
                  ismfNotice
                );
              }
            }
          } catch (e) {
            console.log("讀取招攬資格錯誤");
          }
        }
        return res(isOK);
      });
    },
    //高齡招攬資格卡控
    async checkEldQualification(ismfNotice = false) {
      let isOK = true;
      return new Promise(async (res) => {
        try {
          let validRes = this.$store.getters.EldqualificationObj;
          if (!validRes.hasQualification) {
            //未讀取過高齡招攬資格
            validRes = {
              ...(await this.$mfAPI.MFA0_2100__checkEldQualification({
                agent_id: this.$store.getters.UserInfo.id,
                channel_type: this.$store.getters.UserChannelType,
              })),
            };
            if (validRes.returnCode == "0") {
              this.$store.commit("set_eldqualificationObj", validRes);
            }
          }
          if (validRes.hasQualification == "N") {
            //無招攬資格
            isOK = false;
            //遇到N回傳FALSE，並顯示錯誤訊息
            if (ismfNotice) {
              this.$mfNotice(
                validRes.message_title,
                () => {},
                false,
                () => {},
                "確定",
                validRes.message_body
              );
            } else {
              //黑底白字訊息
              this.$toast.info({
                title: validRes.message,
              });
            }
          }
        } catch (e) {
          console.log("讀取高齡招攬資格錯誤");
        }

        return res(isOK);
      });
    },
    //超連結到CRM客戶資訊頁
    routeToCustDetail(custId) {
      // MXF1 僅回傳客戶識別值；一般 CRMVUE 則維持原本的 detail 導頁。
      if (this.postMxf1Customer(custId)) return;

      localStorage.CustID = custId;
      this.$router.push({ path: `/detail/CustID/tab/1` });
    },
  },
};
